<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card shadow="never">
          <el-row :gutter="20">
            <el-col class="text-md-left" :span="8">
                <el-input
                    placeholder="ค้นหา"
                    v-model="searchText"
                    @input="onSearch()"
                    >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </el-col>
            <el-col :span="6" class="text-md-left">
                <el-button type="primary" @click="onSearch()">เรียกข้อมูล</el-button>
                 <el-button type="danger" @click="exportExcel()">user created order</el-button>
            </el-col>
            <el-col class="text-md-right btn-box" :span="10">
                    <FilterDropdown
                        :dateSort="false"
                        :fixedstatus="true"
                        ref="dropdownParent"
                        :filterDropdownCase.sync="filterDropdownCase"
                        :isOpenFilterDropdown="isOpenFilterDropdown"
                        :handleChangeVisibility="handleChangeVisibility"
                    >
                        <template v-slot:closeFilter>
                            <el-button @click="cancelFilter" data-testid="btnCancel" style="width:100%">
                                Cancel
                            </el-button>
                        </template>
                        <template v-slot:searchFilter>
                            <el-button type="primary" style="width:100%" @click="onSearch">
                                Submit
                            </el-button>
                        </template>
                    </FilterDropdown>
                    <div class="btn-export-box">
                        <el-button type="primary" class="btn-export" @click="isDialogExportCustomer = true">Export</el-button>
                    </div>
                </el-col>
        </el-row>
        <el-row style="margin-top:10px">
            <el-col class="text-md-left" :sm="24">
                <el-table
                    v-loading="loadingTable"
                    :data="userList"
                    stripe
                    :default-sort = "{prop: 'createdAt', order: 'descending'}"
                    :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'left'}"
                    style="width: 100%"
                    ref="customerTable"
                    row-key="userId"
                    @selection-change="handleSelectionChange">
                    <el-table-column v-model="customerSelection" :reserve-selection="true" type="selection" align="center" width="55" />
                    <el-table-column fixed prop="userCode" class="text-md-left" label="รหัสลูกค้า" width="120"></el-table-column>
                    <el-table-column  label="ชื่อลูกค้า" width="200">
                        <div class="text-md-left" slot-scope="scope">
                            {{scope.row.firstName}} {{scope.row.lastName}}
                        </div>
                    </el-table-column>
                    <el-table-column prop="email" label="อีเมล์" min-width="200"></el-table-column>
                    <el-table-column prop="phoneNumber" label="เบอร์โทรลูกค้า" width="150"></el-table-column>
                     <el-table-column label="Type" width="100">
                        <div class="text-md-left" slot-scope="scope">
                            <div v-for="(item,index) in scope.row.sellType" :key="index">{{item}}</div>
                        </div>
                    </el-table-column>
                     <el-table-column label="Quantity" width="150">
                        <div class="text-md-left" slot-scope="scope">
                            {{scope.row.parcelQuantity}}
                        </div>
                    </el-table-column>
                    <el-table-column prop="isVerify" label="ยืนยัน">
                        <div class="text-md-left" slot-scope="scope">
                            <i :style="{'color' : scope.row.isVerify ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isVerify, 'el-icon-close': !scope.row.isVerify}"></i>
                        </div>
                    </el-table-column>
                    <el-table-column prop="isEmailVerify" label="ยืนยันอีเมล์" width="100">
                        <div class="text-md-left" slot-scope="scope">
                            <i :style="{'color' : scope.row.isEmailVerify ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isEmailVerify, 'el-icon-close': !scope.row.isEmailVerify}"></i>
                        </div>
                    </el-table-column>
                    <el-table-column prop="Activate" label="Activate" width="100">
                        <div class="text-md-left" slot-scope="scope">
                            <i :style="{'color' : scope.row.isActivate ? '#67C23A' : '#F56C6C', 'font-size': '1.5rem'}" :class="{'el-icon-check' : scope.row.isActivate, 'el-icon-close': !scope.row.isActivate}"></i>
                        </div>
                    </el-table-column>
                    <el-table-column  label="New/Exist" width="100">
                        <div class="text-md-left" slot-scope="scope">
                            {{getCustomerStatusAccount(scope.row.userStatus)}}
                        </div>
                    </el-table-column>

                    <el-table-column  label="สถานะแพ็คเกจ" width="150">
                        <div class="text-md-left" slot-scope="scope" >
                            {{getSubscriptionStatusLabel(scope.row.subscriptionStatus)}}
                        </div>
                    </el-table-column>

                    <el-table-column  label="สถานะการจ่ายเงิน"  width="150">
                        <div class="text-md-left" slot-scope="scope">
                            {{getSubscriptionPaymentStatusLabel(scope.row.subscriptionStatus)}}
                        </div>
                    </el-table-column>

                    <el-table-column  label="การยืนยันตัวตน"  width="150">
                        <div class="text-md-left" slot-scope="scope">
                            {{getApproveStatusLabel(scope.row.approveStatus, scope.row.isApprove) }}
                        </div>
                    </el-table-column>

                    <el-table-column prop="createdAt" label="สร้างเมื่อ" width="180">
                        <template slot-scope="scope">
                            {{scope.row.createdAt | dayjs('format', 'YYYY-MM-DD HH:mm:ss')}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="จำนวนออเดอร์" width="150">
                        <template slot-scope="scope">
                            <div v-for="(item,key) in countCourier[scope.row.userId]" :key="key">
                                <p><b>{{key}}</b> : {{item.count}}  <i class="el-icon-info" @click="showDetail(item,key)"></i></p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="จัดการ" width="150">
                        <template slot-scope="scope">
                            <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="warning" plain @click="showUserDetail(scope.row)"></el-button>
                            <el-button :key="scope.$index+'-shop'" size="small" icon="el-icon-document" type="info" plain @click="showShop(scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="margin-top:10px;">
                <el-pagination
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit">
                </el-pagination>
            </el-col>
        </el-row>
        </el-card>
      </el-col>
    </el-row>
    <modal-shop-detail  :data.sync="shopDetailDialog"
                        :geoHierarchyData="geoHierarchyData"
                        :provinceArray="provinceArray"
                        :zipcodeArray="zipcodeArray"
                        @close="fetchListUser"
    />
    <customer-base
        :detail.sync="customerDetail"
        :geoHierarchyData="geoHierarchyData"
        :provinceArray="provinceArray"
        :objUser="userDetail"
        @refreshUser="fetchListUser"
        @closeModalCustomer="closeDialog"
    />
    <dialog-create-order-list :detail.sync="dialogCreateOrderList"/>
    <dialog-export-customer
        :isDialogExportCustomer="isDialogExportCustomer"
        :customerSelected="customerSelection"
        :customerFilter="filterDropdownCase"
        :searchTextForFilter="searchText"
        customerType="leadPoolCreatedOrder"
        @onCloseDialog="isDialogExportCustomer = false"
        @onExportSuccess="$refs.customerTable.clearSelection()" />
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import ModalShopDetail from '@/components/Shop/DialogShop'
import DialogCreateOrderList from '@/components/leadpool/DialogNewCustomerCreateOrderList'
import onlineOperationUtility from '@/mixins/onlineOperationUtility.js'
import mixinExcel from '@/mixins/exportExcel.js'
import humps from 'humps'
import CustomerBase from '@/components/Customer/CustomerBase'
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown'
import DialogExportCustomer from '@/components/helper/DialogExportCustomer.vue'

export default {
    components: {
        ModalShopDetail,
        DialogCreateOrderList,
        CustomerBase,
        FilterDropdown,
        DialogExportCustomer
    },
    mixins: [onlineOperationUtility, mixinExcel],
    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            isOpenFilterDropdown: false,
            filterDropdownCase: {
                package_code: null,
                subscription_type: null,
                account_status: null,
                expire_within: false
            },
            filterDropdownShowCase: {
                package_code: null,
                subscription_type: null,
                account_status: null,
                expire_within: false
            },
            searchText: '',
            loadingTable: false,
            userList: [],
            timeoutSearch: null,
            geoHierarchyData: {},
            provinceArray: [],
            dialogShow: false,
            userDetail: {},
            dialogCustomer: false,
            listProvider: [],
            shopIds: [],
            dialogShopShow: false,
            shopInfoSel: {},
            customerDetail: {
                dialog: false,
                data: {},
                operationTag: [],
                pickupAddressShop: [],
                isSelectAddress: false,
                isCheckDelete: false,
                isCheckEditBooking: false
            },
            shopDetailDialog: {
                dialogVisible: false,
                shopDetail: {}
            },
            zipcodeArray: [],
            statusFilter: 0,
            countCourier: {},
            dialogCreateOrderList: {
                dialog: false,
                courierName: null,
                orderList: null
            },
            isDialogExportCustomer: false,
            customerSelection: [],
            baseSubscriptionData: {}
        }
    },
    created () {
        let zipcodeArr = []

        // this.fetchListProvider()
        let geoJsonData = require('@/assets/geo.json')
        geoJsonData.forEach(e => {
            if (!(e['province'] in this.geoHierarchyData)) {
                this.geoHierarchyData[e['province']] = {}
            }
            if (!(e['amphoe'] in this.geoHierarchyData[e['province']])) {
                this.geoHierarchyData[e['province']][e['amphoe']] = {}
            }
            if (
                !(
                    e['district'] in
                    this.geoHierarchyData[e['province']][e['amphoe']]
                )
            ) {
                this.geoHierarchyData[e['province']][e['amphoe']][e['district']] = e['zipcode']
                if (e['zipcode']) {
                    zipcodeArr.push(String(e['zipcode']))
                }
            }
        })
        for (let provice in this.geoHierarchyData) {
            this.provinceArray.push(provice)
        }
        zipcodeArr = [...new Set(zipcodeArr)]
        this.zipcodeArray = zipcodeArr.sort()
        this.fetchListUser()
    },
    methods: {
        cancelFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
            this.filterDropdownCase = this.filterDropdownShowCase
        },
        closeFilter () {
            this.isOpenFilterDropdown = false
            this.$nextTick(() => {
                this.$refs.dropdownParent.$refs.dropdown.hide()
            })
        },
        handleChangeVisibility (value) {
            this.isOpenFilterDropdown = value
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchListUser()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchListUser()
        },
        onSelectStatusFilter () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListUser()
        },
        onSearch () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListUser()
            if (JSON.stringify(this.filterDropdownCase) !== JSON.stringify(this.filterDropdownShowCase)) {
                this.filterDropdownShowCase = this.filterDropdownCase
            }
            this.closeFilter()
            this.$refs.customerTable.clearSelection()
        },
        async fetchListUser () {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    user_status: parseInt(this.statusFilter),
                    is_created_order: true,
                    expire_within: this.filterDropdownCase.expire_within ? 7 : null,
                    account_status: this.filterDropdownCase.account_status,
                    subscription_type: this.filterDropdownCase.subscription_type,
                    package_code: this.filterDropdownCase.package_code
                    // is_new: null,
                    // is_approve: false,
                }
                // let res = await fgApi.user.getUserListOptSnakeaCase(param)
                let res = await fgApi.user.searchWaitingUserSnakeaCase(param)
                if (res.success) {
                    if (this.searchText === param.search) {
                        this.userList = res.data ? humps.camelizeKeys(res.data) : []
                        this.countCourier = res.created_orders
                        this.pagination.allPage = res.all_page
                    }
                }

                this.loadingTable = false
            }, 1000)
        },
        async fetchListProvider () {
            let res = await fgApi.courier.getListProvider()
            this.listProvider = res.data
        },
        async showUserDetail (data) {
            this.customerDetail.dialog = !this.customerDetail.dialog
            await this.onGetSubscription(data.userId)
            this.customerDetail.data = { ...data, ...this.baseSubscriptionData }
            this.customerDetail.operationTag = []
            let param = {
                user_id: data.userId
            }
            try {
                let getAllPickupAddress = await fgApi.user.getAllPickupAddressShop(param)
                if (getAllPickupAddress.success) {
                    this.customerDetail.pickupAddressShop = getAllPickupAddress.data
                }
                let operationTagRes = await fgApi.log.getOperationCancelTag(param)
                if (operationTagRes.success) {
                    for (let calcelOnline in operationTagRes.data) {
                        this.customerDetail.operationTag.push(this.getOperationTag(operationTagRes.data[calcelOnline]))
                    }
                } else {
                    alert(operationTagRes.message)
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
        },
        closeDialog () {
            this.customerDetail.dialog = !this.customerDetail.dialog
            this.customerDetail.data = { }
        },
        showDetail (item, key) {
            this.dialogCreateOrderList.dialog = !this.dialogCreateOrderList.dialog
            this.dialogCreateOrderList.courierName = key
            let orderList = item.order_numbers.map((e, index) => {
                return {
                    no: index + 1,
                    orderNumber: e
                }
            })
            this.dialogCreateOrderList.orderList = orderList
        },
        async showShop (data) {
            this.$loading()
            let param = {
                target_user_id: data.userId,
                search: '',
                limit: null,
                offset: null
            }
            try {
                let res = await fgApi.shop.searchListShop(param)
                if (res.data.length === 0) {
                    this.$notify.info({
                        title: 'Info',
                        message: 'No shop'
                    })
                    this.$loading().close()
                    return
                }
                if (res.success) {
                    this.shopIds = []
                    res.data.forEach(e => this.shopIds.push({ shopId: String(e.shopId), shopName: e.name }))
                    let shopFrist = res.data[0]
                    Object.entries(shopFrist.financeConfig).forEach(e => {
                        shopFrist.financeConfig[e[0]]['zipcodeArr'] = []
                        Object.entries(shopFrist.financeConfig[e[0]].remoteZone).forEach(s => {
                            if (s[0] !== 'cost') {
                                shopFrist.financeConfig[e[0]].zipcodeArr.push(s[0])
                            }
                        })
                    })
                    if (shopFrist.bankName === 0) {
                        shopFrist.bankName = null
                    }
                    // this.shopInfoSel = shopFrist
                    // this.dialogShopShow = !this.dialogShopShow
                    this.shopDetailDialog.dialogVisible = !this.shopDetailDialog.dialogVisible
                    this.shopDetailDialog.shopDetail = JSON.parse(JSON.stringify(shopFrist))
                    this.$loading().close()
                }
            } catch (error) {
                this.$notify.info({
                    title: 'Info',
                    message: error
                })
            }
        },
        async exportExcel () {
            this.$loading()
            let param = {
                search: '',
                limit: null,
                offset: null,
                user_status: parseInt(2),
                is_created_order: true
                // is_new: null,
                // is_approve: false,
            }
            // let res = await fgApi.user.getUserListOptSnakeaCase(param)
            let res = await fgApi.user.searchWaitingUserSnakeaCase(param)

            if (res.success) {
                let excelHeader = [
                    [
                        'รหัสลูกค้า',
                        'ชื่อลูกค้า',
                        'อีเมล',
                        'เบอร์โทรลูกค้า',
                        'ยืนยัน',
                        'ยันยันอีเมล',
                        'Active',
                        'New/Exist',
                        'สร้างเมื่อ'
                    ]
                ]
                let mapData = (e) => {
                    return [
                        e.user_code,
                        `${e.first_name} ${e.last_name}`,
                        e.email,
                        e.phone_number,
                        e.is_verify,
                        e.is_email_verify,
                        e.is_activate,
                        this.getCustomerStatusAccount(e.user_status),
                        this.$dayjs(e.created_at).format('YYYY-MM-DD HH:mm:ss')
                    ]
                }
                res.data.forEach(e => {
                    let temArr = mapData(e)
                    excelHeader.push(temArr)
                })
                this.saveExcel(excelHeader, 'user_created_order')
            }
            this.$loading().close()
        },
        async onGetSubscription (userId) {
            try {
                const param = {
                    userId: userId
                }

                const res = await fgApi.subscription.getSubscription(param)

                const convertToPropsData = {
                    subscriptionData: { ...res.data }
                }

                this.baseSubscriptionData = convertToPropsData
            } catch (error) {
                const convertToPropsData = {
                    subscriptionData: null
                }

                this.baseSubscriptionData = convertToPropsData
            }
        },
        handleSelectionChange (val) {
            this.customerSelection = val
        }
    }
}
</script>

<style lang="scss" scoped>
.el-icon-info {
  cursor: pointer;
}
.btn-box {
    display: flex;
    justify-content: flex-end;
    .btn-export-box {
        margin-left: 16px;
        .btn-export {
            width: 90px;
            height: 40px;
        }
    }
}
</style>
